<template>
  <div>
    <b-row>
      <b-col
        cols="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 640px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <!-- Map🚀 -->
            <l-map
              ref="mymap"
              :zoom="zoom"
              :center="center"
              style="width: 100%; height: 590px; z-index: 0"
              :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false, dragging:true, doubleClickZoom: true, permanent: true}"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              />
              <l-marker
                v-for="(markerDB, index) in markersDB"
                :key="'markerDB'+index"
                ref="markerDB"
                :lat-lng="[markerDB.latitude, markerDB.longitude]"
                @click="getInfoCountingDB(markerDB.wid, markerDB.deptid, markerDB.wayid, markerDB.type_name, markerDB.analyticType, markerDB.analyticGroup)"
              >
                <!-- :icon-size="[34, 46]" -->
                <l-icon
                  v-if="markerDB.type_name === 'Counting' || markerDB.type_name === 'Counting7'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Counting.svg')"
                />
                <!-- <l-icon
                  v-if="markerDB.type_name === 'CCTV'"
                  :icon-size="[16, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/CCTV.svg')"
                /> -->
                <l-icon
                  v-if="markerDB.type_name === 'TrafficSign'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/VMS Sign.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Traffic'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Traffic.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Flooding'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Flooding.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name !== 'Counting' & markerDB.type_name !== 'Counting7'
                    & markerDB.type_name !== 'TrafficSign'
                    & markerDB.type_name !== 'Traffic' & markerDB.type_name !== 'Flooding'
                    & markerDB.type_name !== 'Lighting' & markerDB.type_name !== 'Foodlight'
                    & markerDB.type_name !== 'Analytic' & markerDB.type_name !== 'Tunnel'
                    & markerDB.type_name !== 'Bridge' & markerDB.type_name !== 'Kiosk'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Sensor.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Lighting'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Lighting.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'FloodLight'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Foodlight.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Analytic'"
                  :icon-size="[24, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Analytic.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Tunnel'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Tunnel.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Bridge'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Bridge.svg')"
                />
                <l-icon
                  v-if="markerDB.type_name === 'Kiosk'"
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/iconsDB/Kiosk.svg')"
                />

                <!-- ปริมาณจราจร -->
                <l-popup
                  v-if="markerDB.type_name === 'Counting' || markerDB.type_name === 'Counting7'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">ปริมาณจราจร</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersDB"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/counting-detail?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- กล้องวงจรปิด -->
                <!-- <l-popup
                  v-if="markerDB.type_name === 'CCTV'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">กล้องวงจรปิด</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersCCTV"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/cctv-detail?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup> -->

                <!-- ป้าย VMS -->
                <l-popup
                  v-if="markerDB.type_name === 'TrafficSign'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">ป้าย VMS</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersTrafficSign"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/vms-detail?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- ไฟจราจรอัจฉริยะ -->
                <l-popup
                  v-if="markerDB.type_name === 'Traffic'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">ไฟจราจรอัจฉริยะ</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersTraffic"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/#?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- ระดับน้ำ -->
                <l-popup
                  v-if="markerDB.type_name === 'Flooding'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">ระดับน้ำ</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersFlooding"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/#?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- เซ็นเซอร์ -->
                <l-popup
                  v-if="markerDB.type_name !== 'Counting' & markerDB.type_name !== 'Counting7'
                    & markerDB.type_name !== 'TrafficSign' & markerDB.type_name !== 'Count7Analytic'
                    & markerDB.type_name !== 'Traffic' & markerDB.type_name !== 'Flooding'
                    & markerDB.type_name !== 'Lighting' & markerDB.type_name !== 'Foodlight'
                    & markerDB.type_name !== 'Analytic' & markerDB.type_name !== 'Tunnel'
                    & markerDB.type_name !== 'Bridge' & markerDB.type_name !== 'Kiosk'
                    & markerDB.type_name !== 'CountAnalytic'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">เซ็นเซอร์</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersSenser"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/#?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- ระบบแสงสว่าง -->
                <l-popup
                  v-if="markerDB.type_name === 'Lighting'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">ระบบแสงสว่าง</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersLighting"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/#?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- ระบบไฟประดับ -->
                <l-popup
                  v-if="markerDB.type_name === 'FloodLight'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">ระบบไฟประดับ</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersFloodLight"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/#?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- Analytic -->
                <l-popup
                  v-if="markerDB.type_name === 'Analytic' || markerDB.type_name === 'Count7Analytic' || markerDB.type_name === 'CountAnalytic'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">Analytic</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersAnalytic"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          v-if="data.item.analyticType === 0"
                          id="toggle-btn"
                          variant="success"
                          :to="`/analytic-detail?wid=${data.item.wid}&type=${data.item.analyticGroup}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                        <b-button
                          v-if="data.item.analyticType === 1"
                          id="toggle-btn"
                          variant="success"
                          :to="`/analytic-detailCarstop?wid=${data.item.wid}&type=${data.item.analyticGroup}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- อุโมงค์ -->
                <l-popup
                  v-if="markerDB.type_name === 'Tunnel'"
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">อุโมงค์</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="sm"
                      :items="itemsDB"
                      :fields="fieldsmarkersTunnel"
                      small
                      stacked
                    >
                      <template
                        #cell(wid)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/#?wid=${data.item.wid}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </l-popup>

                <!-- สะพาน -->
                <!-- <l-popup
                      v-if="markerDB.type_name === 'Bridge'"
                      ref="popup"
                    >
                      <div>
                        <b-table
                          class="table table-borderless"
                          style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                          responsive="sm"
                          :items="itemsDB"
                          :fields="fieldsmarkersBridge"
                          small
                          stacked
                        />
                      </div>
                    </l-popup> -->
              </l-marker>
              <!-- <l-polygon
                    :lat-lngs="polygon.latlngs"
                    :color="polygon.color"
                  /> -->

              <!-- -------------- แยกหมุด CCTV ------------- -->
              <l-marker
                v-for="(marker, index) in markercctv"
                :key="'marker'+index"
                :ref="'marker'+index"
                :lat-lng="[marker.latitude, marker.longitude]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="getInfoCount(marker.wayid, marker.detail, marker.id)"
              >
                <l-icon
                  :icon-size="[20, 46]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/MakerCCTV.svg')"
                />
                <l-popup
                  ref="popup"
                >
                  <div>
                    <span style="font-size: 17px; color:#fff;">กล้องวงจรปิด</span>
                    <b-table
                      class="table table-borderless"
                      style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                      responsive="lg"
                      :items="itemsCount"
                      :fields="fieldsmarkersCCTV"
                      small
                      stacked
                      foot-clone
                    >
                      <template
                        #cell(id)="data"
                        colspan="2"
                      >
                        <b-button
                          id="toggle-btn"
                          variant="success"
                          :to="`/cctv-detail?wid=${data.item.id}`"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>

                      </template>
                    </b-table>
                  </div>
                </l-popup>
                <!-- <l-popup
                  ref="popup"
                >
                  <div>
                    <span style="color:white; padding: 1px; text-align: left; font-size:14px;">
                      ตำแหน่ง:{{ camdesc }}
                    </span>
                    <video
                      id="video"
                      style="width:250px; height:auto; flex-direction: row;"
                      muted
                      autoplay
                      playsinline
                    />
                  </div>
                </l-popup> -->
              </l-marker>
            </l-map>
          </div>
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow,
  BCol,
  VBModal,
  BCard,
  BTable,
  BButton,
  // BLink,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer,
  LMarker, LIcon, LPopup,
  // LPolygon,
} from 'vue2-leaflet'
import axios from '@axios'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import Ripple from 'vue-ripple-directive'
import { Icon } from 'leaflet'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    // LPolygon,
    BCard,
    BTable,
    BButton,
    // BLink,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 6,
      center: [13.7649084, 100.5360959],
      // polygon: {
      //   latlngs: [[16.601781739489386, 104.73596383726264], [16.557298105891203, 104.72889133603388], [16.60135813435211, 104.70944195765473], [16.600934528281115, 104.73286961797506]],
      //   color: '#7367F0',
      // },
      markersDB: [],
      markercctv: [],

      itemsDB: [],
      attribution: '',
      camdesc: '',

      fieldsmarkersDB: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersCCTV: [
        { key: 'detail', label: 'จุดติดตั้ง:', class: 'text-center' },
        { key: 'id', label: '', class: 'text-center' },
      ],
      fieldsmarkersTrafficSign: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersTraffic: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersFlooding: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersSenser: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersLighting: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersFloodLight: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersAnalytic: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersTunnel: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      // fieldsmarkersBridge: [
      //   {
      //     key: 'wayid', label: 'สายทาง:',
      //   },
      //   {
      //     key: 'type_name', label: 'สถานะ:',
      //   },
      // ],
      itemsCount: [],
      TypeName: ['Counting', 'Counting7', 'CCTV', 'TrafficSign', 'Traffic', 'Flooding', 'Lighting', 'FloodLight', 'Analytic', 'Tunnel', 'Bridge'],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
    this.getMarkerDB()
    if (this.userData.groupname === 'psd') {
      this.zoom = 12
    } else if (this.userData.department !== '0') {
      this.zoom = 10
    }
  },
  mounted() {
    this.getMarkerCCTV()
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
  },
  methods: {
    getMarkerDB() {
      axios
        .post('/getMarkerDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          if (this.userData.department !== '0') {
            this.center.splice(0)
            this.center.push(response.data[0].latitude)
            this.center.push(response.data[0].longitude)
          }
          this.wayid = response.wayid
          this.markersDB = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    // -------------- แยกหมุด CCTV -------------
    getMarkerCCTV() {
      axios
        .post('/getMapTotalCCTV', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          this.markercctv = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    // eslint-disable-next-line camelcase
    getInfoCountingDB(wid, deptid, wayid, type_name, analyticType, analyticGroup) {
      this.itemsDB = []
      this.itemsDB.push({
        wid,
        deptid,
        wayid,
        type_name,
        analyticType,
        analyticGroup,
      })
    },
    getInfoCount(WayID, detail, id) {
      this.itemsCount = []
      this.itemsCount.push({
        WayID,
        detail,
        id,
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  // .vue2leaflet-map{
  //   &.leaflet-container{
  //     width: 1454px;
  //     height: 590px;
  //   }
  // }
  .leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
  .leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.85);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}

</style>
